// extracted by mini-css-extract-plugin
export var avatarContainer = "_ea-0";
export var gray = "_ea-f";
export var green = "_ea-c";
export var icon = "_ea-9";
export var image = "_ea-1";
export var lg = "_ea-6";
export var md = "_ea-5";
export var presenceDot = "_ea-b";
export var red = "_ea-d";
export var sm = "_ea-4";
export var status = "_ea-a";
export var xl = "_ea-7";
export var xs = "_ea-3";
export var xxl = "_ea-8";
export var xxs = "_ea-2";
export var yellow = "_ea-e";